var _metadata, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPearIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 519.69336 620.37335",
    height: 620.37335,
    width: 519.69336,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,620.37333)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#bbf3b4",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 52.0508,2015.86 C -79.5039,1777.15 45.6055,1432.88 344.973,1100.04 279.043,1080.52 228.445,1045.4 200.23,994.191 103.539,818.73 304.82,522.383 649.785,332.273 994.762,142.168 1352.81,130.281 1449.5,305.742 c 5.55,10.059 9.99,20.547 13.61,31.36 683.27,-280.1762 1316.57,-262.2973 1501.68,73.621 34.1,61.867 50.9,130.832 51.96,204.836 282.76,6.074 497.12,92.39 591.08,262.879 117.86,213.882 22.56,517.172 -224.59,827.292 50.1,108.15 58.85,232.55 31.32,365.76 78.42,65.17 143.79,142.73 193.26,232.51 140.47,254.88 129.31,565.45 -2.98,874.55 85.84,31.7 152.05,82.52 190.87,152.98 149.86,271.93 -162.08,731.19 -696.71,1025.81 -470.36,259.2 -956.23,304.51 -1168.36,126.55 -662.94,160.43 -1273.097,11.66 -1512.238,-422.27 -78.308,-142.12 -109.437,-301.55 -98.808,-468.37 -58.688,-44 -106.285,-97.28 -140.805,-159.91 -132.7656,-240.9 -45.406,-571.06 200.586,-900.3 -19.437,-84.92 -13.137,-179.56 16.121,-280.19 C 237.289,2212.44 117.031,2133.77 52.0508,2015.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#95d8ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3561.93,1355.98 C 3328.22,931.895 2462.82,960.605 1628.99,1420.11 795.16,1879.61 308.66,2595.89 542.375,3019.97 c 233.699,424.1 1099.105,395.39 1932.945,-64.12 833.82,-459.5 1320.32,-1175.78 1086.61,-1599.87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#73cced",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3335.08,761.16 C 3034.5,215.754 2114.9,146.094 1281.07,605.605 447.246,1065.11 14.9492,1879.76 315.523,2425.16 616.09,2970.58 1535.7,3040.23 2369.54,2580.73 3203.36,2121.23 3635.65,1306.59 3335.08,761.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#73cced",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3335.09,2110.81 C 3124.92,1729.47 2278.61,1792.83 1444.79,2252.34 610.953,2711.82 105.367,3393.46 315.516,3774.8 525.668,4156.15 1371.98,4092.79 2205.82,3633.28 3039.65,3173.79 3545.22,2492.15 3335.09,2110.81"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#52c1ec",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 3681.91,2697.96 C 3477.27,2326.61 2694.06,2365.74 1932.56,2785.39 1171.07,3205.02 719.652,3846.25 924.313,4217.6 c 204.637,371.36 987.847,332.22 1749.357,-87.42 761.47,-419.63 1212.9,-1060.86 1008.24,-1432.22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#95d8ef",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1970.63,442.234 C 1828.75,184.816 1303.42,202.234 797.25,481.172 291.09,760.117 -4.23438,1194.91 137.641,1452.36 c 141.867,257.44 667.199,240 1173.379,-38.93 506.15,-278.93 801.47,-713.75 659.61,-971.196"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#1fadea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 3541.63,3665.21 c -91.53,-166.1 -430.5,-154.86 -757.12,25.13 -326.6,179.98 -517.16,460.54 -425.62,626.66 91.54,166.11 430.52,154.86 757.13,-25.13 326.6,-179.97 517.16,-460.54 425.61,-626.66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#1fadea",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 111.238,1753.61 C 41.7344,1585.52 89.8672,1408.18 162.91,1269.7 237.676,1128.06 338.32,1007.71 452.219,897.031 l 43.676,-40.976 5.488,-5.137 2.742,-2.578 0.348,-0.32 c -0.68,-5.735 7.847,48.64 3.996,25.535 l -0.891,-0.403 -1.777,-0.808 -14.223,-6.504 c -9.644,-3.992 -18.547,-9.832 -27.879,-14.746 -36.109,-21.66 -69.644,-52.278 -90.676,-92.071 -44.031,-81.699 -22.64,-182.253 21.7,-260.058 C 486.965,340.148 648.059,219.043 841.586,126.445 947.309,79.2969 1113.08,9.85547 1333.03,0.234375 1440.19,-1.42578 1570.39,3.51563 1679.62,88.4453 c 27.31,20.5077 47.99,50.5197 63.61,82.5707 4.29,7.871 5.81,16.964 8.79,25.468 l 3.9,13.008 0.48,1.629 c 22.74,14.055 -30.54,-17.117 -24.4,-14.246 l 3,-0.809 6,-1.625 48.4,-13.074 c 65.19,-16.777 132.55,-32.695 202.13,-45.82 276.43,-49.9103 594.53,-79.3361 904.2,16.758 150.56,48.586 305.77,144.101 372.1,303.152 15.36,39.152 26.5,79.926 30.88,121.66 0.77,20.852 4.66,41.781 2.58,62.563 l -1.43,31.187 -0.37,7.805 -0.09,1.941 c 15.31,20.461 -21.15,-25.515 -16.51,-20.828 l 3.75,0.586 15.04,2.332 c 80.09,12.309 159.64,30.363 235.59,59.121 150.05,54.121 295.93,163.188 341.66,321.916 47.49,157.19 -2.55,317.04 -69.53,443.95 -68.64,129.4 -158.64,237.51 -249.59,331.26 l -17.01,17.58 -4.23,4.37 c -4.77,18.73 5.19,-24.33 4.46,-19.31 l 0.42,1.52 0.85,3 3.38,12.02 c 4.59,15.95 9.17,31.78 11.56,47.96 6.44,31.96 9.47,64.08 9.58,95.4 0.88,62.82 -8.41,122.79 -22.65,178.33 l -12,40.78 -1.49,5.03 -0.38,1.25 c -2.08,-8.6 4.15,21.01 -4.75,-18.96 l 1.72,1.96 6.84,7.82 13.58,15.5 c 18.27,20.31 35.6,40.51 50.15,62.08 31.42,41.28 55.96,84.27 76.37,125.44 41.73,82.37 62.08,160.7 73.69,225.03 21.24,129.83 9.48,204.25 11.24,204 -0.87,-0.36 -0.09,74.66 -32.33,201.17 -16.18,63.08 -41.66,138.56 -80.68,221.06 -10.31,20.32 -19.69,42.01 -31.71,63.1 l -17.64,32.46 -4.49,8.26 c -16.58,-55.46 -3.99,-15.04 -7.41,-27.27 l 1.06,0.59 2.13,1.16 4.28,2.35 17.21,9.47 c 45.85,25.98 90.33,62.71 125.06,111.2 72.93,97.85 74.26,244.61 19.16,365.8 -52.7,123.73 -144.21,233.92 -251.35,331.45 -216.18,194.81 -499.94,343.66 -807.64,431.5 -153.96,44.08 -315.45,70.52 -478.25,70.71 -160.51,-3.33 -331.99,-25.76 -465.43,-128.74 l -23.15,-20.92 -11.53,-10.48 -2.87,-2.62 -1.44,-1.31 c -15.8,-5.91 19.96,6.42 15.56,5.37 l -7.39,0.82 -58.95,6.44 c -39.3,3.54 -78.47,6.47 -117.53,8.28 -78.1,3.53 -155.59,3.09 -231.81,-1.52 -152.38,-9.2 -299.85,-35.21 -435.523,-79.08 -272.012,-85.07 -492.793,-254.48 -600.938,-447.4 -111.723,-191.98 -120.523,-379 -111.644,-494.28 1.839,-27.11 4.539,-53.75 9.031,-79.8 l 2.91,-19.52 0.727,-4.86 0.363,-2.43 0.094,-0.61 c 11.816,35.88 3.027,9.69 5.55,17.58 l -0.859,-0.9 -6.887,-7.17 -27.254,-28.52 c -33.472,-40 -63.8005,-81.92 -83.3786,-128.04 C 22.6797,3142.54 13.6758,3044.26 21.7031,2954.51 41.3789,2773.06 124.379,2623.05 216.66,2494.57 c 47.133,-64.34 97.879,-124.41 152.207,-180.98 -2.523,-56.69 5.485,-153.97 33.367,-224.37 6.207,-19.09 14.094,-37.59 21.739,-56.27 -4.278,9.41 -33.055,-11.5 -48.5,-15.83 -36.539,-18.14 -72.153,-38.96 -105.946,-63.6 -66.914,-49.71 -124.961,-117.18 -158.289,-199.91 36.356,81.52 96.102,145.87 163.551,192.54 34.09,23.12 69.777,42.4 106.234,59.04 19.258,12.49 35.555,3.86 56.899,33.57 -6.914,18.56 -14.074,36.92 -19.547,55.73 -27.77,78.02 -23.766,144.75 -32.145,235.33 -52.183,57.32 -100.707,117.7 -145.578,181.77 -87.937,127.77 -165.3707,275.23 -181.9411,446.33 -6.6015,84.64 2.4454,175.37 43.0821,258.63 18.18,42.5 46.488,81.02 77.586,118.13 l 25.465,26.49 6.402,6.69 0.805,0.84 c 2.754,8.19 -5.602,-17.76 6.273,18.47 l -0.082,0.59 -0.344,2.33 -0.679,4.68 -2.754,18.77 c -4.301,25.06 -6.844,50.62 -8.582,76.61 -8.426,110.67 0.133,288.48 106.418,471.1 102.742,183.27 313.73,346.37 578.601,429.34 131.988,42.67 276.148,68.17 425.538,77.18 74.72,4.52 150.79,4.95 227.52,1.49 38.38,-1.78 76.88,-4.66 115.53,-8.14 l 57.97,-6.34 7.27,-0.8 c -3.05,-1.6 33.49,11.97 18.62,6.84 l 1.29,1.16 2.59,2.33 10.35,9.33 20.65,18.77 c 120.02,93.5 285.02,117.25 440.5,119.98 157.95,-0.17 316.11,-25.91 467.1,-69.16 301.9,-86.03 581.32,-232.89 791.53,-422.5 104.27,-94.71 192.23,-201.6 241.35,-317.24 51.17,-114.25 48.31,-241.71 -14.97,-327.09 -30.49,-42.5 -70.1,-75.67 -112.33,-99.56 l -15.87,-8.73 -3.93,-2.16 -1.96,-1.08 -0.98,-0.54 c -4.02,-12.63 7.62,27.49 -9.26,-28.44 l 4.37,-8.05 17.18,-31.6 c 11.72,-20.53 20.8,-41.6 30.84,-61.36 37.93,-80.16 62.57,-153.19 78.18,-214.04 31.11,-122.03 30.29,-193.71 31.15,-193.39 -1.7,0.26 9.52,-71.17 -10.75,-194.83 -11.09,-61.28 -30.41,-135.79 -70.17,-214.16 -19.45,-39.16 -42.75,-80.08 -72.74,-119.4 -13.82,-20.58 -30.4,-39.84 -47.86,-59.22 l -12.94,-14.8 -6.53,-7.48 -1.63,-1.88 c -9.33,-40.62 -2.38,-11.94 -4.38,-21.32 l 0.35,-1.2 1.41,-4.78 11.42,-38.76 c 13.48,-52.69 22.14,-109.1 21.32,-167.55 -0.08,-29.17 -2.92,-58.92 -8.9,-88.41 -2.15,-14.96 -6.42,-29.53 -10.66,-44.23 l -3.09,-11.08 -0.77,-2.78 -0.39,-1.39 c -1.37,3.96 9.35,-39.79 5.36,-21.77 l 4.15,-4.27 16.65,-17.23 c 89.16,-91.86 176.94,-197.67 242.81,-322 64.69,-122.24 109.73,-272.13 66.61,-413.38 -40.86,-142.569 -173.18,-243.694 -317.36,-295.96 -72.54,-27.48 -149.5,-45.007 -227.38,-56.965 l -14.61,-2.273 -3.66,-0.566 c 2.94,4.875 -33.83,-42.051 -18.15,-23.106 l 0.08,-1.797 0.32,-7.195 1.3,-28.77 c 2.04,-19.25 -1.77,-38.214 -2.35,-57.335 -3.99,-38.094 -14.16,-74.993 -27.99,-110.516 -59.5,-143.43 -202.42,-233.574 -347.49,-280.383 -297.57,-92.7148 -611.79,-64.961 -884.02,-15.461 -68.62,12.942 -135.1,28.652 -199.46,45.207 l -47.81,12.91 -5.92,1.602 -2.96,0.801 c 4.83,3.703 -48.31,-29.246 -25.97,-15.996 l -0.41,-1.321 -3.26,-10.523 c -2.49,-6.867 -3.41,-14.336 -7.03,-20.695 -12.98,-25.809 -29.09,-50.458 -52.58,-67.833 C 1561.11,46.1602 1436.76,38.0352 1334.47,40.4883 1123.5,49.5117 961.152,116.973 858.559,162.766 670.375,252.195 513.934,370.43 427.203,517.023 c -41.898,72.372 -59.601,158.258 -24.144,226.317 17.031,33.515 45.101,60.5 77.211,80.613 8.382,4.555 16.187,10.012 25,13.82 l 12.894,6.211 1.609,0.774 0.809,0.39 c -3.633,-22.96 5.473,31.485 4.34,26.004 l -0.348,0.301 -2.754,2.492 -5.507,4.961 -43.891,39.512 C 357.816,1025.13 255.664,1140.81 177.867,1277.74 102.055,1411.89 48.2227,1583.15 111.238,1753.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#001f38",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2014.32,3886.25 c 0.11,-94.09 35.01,-179.27 97.42,-249.22 35.34,-39.61 92.48,-47.94 122.82,-93.39 25.24,-37.8 26.98,-92.51 35.66,-135.91 12.08,-60.31 43.18,-111.64 108.76,-116.6 61.67,-4.65 120.97,41.33 182.29,23.91 54.5,-15.49 54.82,-97.81 55.21,-141.56 0.41,-45.57 4.18,-89.09 19.06,-132.47 25.63,-74.8 91.07,-129.35 142.43,-186.34 148.23,-164.45 235.1,-353.71 185.67,-577.81 -3.21,-14.54 17.9,-25.11 25.05,-10.56 63.69,129.49 157.28,242.44 215.27,374.78 52.87,120.62 71.26,256.05 80.19,386.42 17.16,250.52 -58.39,509.55 -220.77,703.07 -137.66,164.08 -376.23,299.28 -596.13,288.61 -45.98,-2.24 -98.82,-25.15 -143.15,-37.33 -75.27,-20.69 -150.55,-41.38 -225.81,-62.07 -24.64,-6.77 -49.27,-13.54 -73.9,-20.31 -17.03,-4.68 -9.79,-31.13 7.28,-26.43 116.75,32.09 233.51,64.18 350.26,96.27 13.1,3.6 26.2,7.2 39.29,10.8 59.66,16.4 112.52,11.44 173.34,-1.15 118.21,-24.47 225.85,-78.02 322.59,-149.48 227.69,-168.19 340.21,-456 341.81,-732.85 0.81,-144.37 -22.14,-294.92 -73.87,-429.95 -53.03,-138.37 -154.86,-253.97 -220.07,-386.55 8.35,-3.52 16.7,-7.04 25.05,-10.56 42.07,190.74 -6.19,364.41 -121.84,519 -52.74,70.51 -119.53,128.89 -172.55,198.81 -31.52,41.57 -45.65,90.02 -50.57,141.33 -4.88,50.83 2.89,100.43 -15.85,149.2 -62.55,162.84 -262.69,-50.25 -322.51,100.11 -27.56,69.28 -12.2,164.44 -79.11,214.16 -48.47,36.01 -94.01,54.82 -130.05,106.78 -38.2,55.08 -55.78,120.85 -55.86,187.29 -0.02,17.68 -27.42,17.68 -27.41,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#39691b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2028.03,3886.25 c -2.46,-95.89 39.42,-181.48 93.4,-239.53 33.37,-35.91 78.49,-42.99 110.37,-76.7 55.97,-59.18 33.82,-179.34 84.72,-236.51 85.64,-96.22 246.87,94.05 304.27,-71.58 13.37,-38.57 7.39,-90.91 10.62,-133.22 7.48,-98.53 46.01,-146.85 102.37,-206.17 152.96,-160.97 312.74,-351.66 243.08,-649.33 57.16,119.05 134.98,216.01 194.92,331.42 60.53,116.46 87.1,268.36 97.46,405.21 19.23,254.12 -43.44,461.43 -167.7,648.15 -95.28,143.14 -261.25,256.56 -401.66,305.86 -66.15,23.22 -218.9,62.81 -282.3,29.47 l -389.55,-107.07"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#3d6f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2028.03,3886.25 c 0,0 1028.86,-216.09 964.2,-1434.43 -14.43,200 -138.51,344.5 -258.45,470.72 -56.36,59.32 -94.89,107.64 -102.37,206.17 -3.23,42.31 2.75,94.65 -10.62,133.22 -57.4,165.63 -218.63,-24.64 -304.27,71.58 -50.9,57.17 -28.75,177.33 -84.72,236.51 -31.88,33.71 -77,40.79 -110.37,76.7 -53.98,58.05 -95.86,143.64 -93.4,239.53"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2037.04,3906.25 c 0,0 838.26,-156.3 952.8,-1165.16 -1.99,-7.45 -16.87,185.95 -117.67,415.38 -119.51,272.04 -359.86,594.73 -842.81,693.29 l 7.68,56.49"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#23551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2741.67,3365.92 c -98.65,112.69 -208.03,238.79 -327.09,314.27 -27.03,17.11 -258.38,116.33 -274.25,39.86 -4.74,-23.06 82.28,-103.66 96.37,-127.71 26.31,-44.93 35.92,-75.55 79.28,-94.71 55.39,-24.45 145.47,-20.42 205.22,-26.95 l 220.47,-104.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2885.42,2874 c -0.26,-3.8 24.19,242.19 -11.05,303.66 -1.97,-2.36 -14.31,31.08 -14.31,31.08 0,0 39.82,-108.72 25.36,-334.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1963.41,4119.4 c 0,0 247.31,57.49 297.18,0 49.84,-57.5 -22.64,-173.14 -73.81,-221.92 -51.17,-48.77 -45.81,-117.75 -10.93,-179.38 -6.13,2.69 -68.15,113.69 -68.15,113.69 0,0 7.99,67.42 52.06,99.74 44.08,32.31 86.81,117.58 63.31,151.7 -23.5,34.11 -158.17,27.91 -214.76,1.76 -56.63,-26.16 -44.9,34.41 -44.9,34.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#120402",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2617.38,3317.69 c -38.6,41.81 -65.22,68.79 -115.53,112.33 -27.76,22.96 -108.31,95.5 -175.35,168.63 -67.71,72.55 -121.07,145.34 -121.25,145.15 0.09,0.01 -54.74,71.76 -104.96,157.15 -51.4,84.76 -94.65,183.98 -107.28,217.55 -28.31,56.44 -26.4,103.61 -72.56,142.99 28.83,-48.52 13.75,-90.4 44.2,-154.34 12.65,-34.33 56.76,-135.54 109.19,-221.84 51.2,-86.97 107.09,-159.85 106.98,-159.86 0.19,0.2 54.38,-73.93 123.1,-147.65 68.03,-74.32 149.74,-147.88 178.02,-170.95 51.31,-43.77 85.14,-62.97 135.44,-89.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#511d0e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2617.38,3317.69 c -155.15,114.8 -296.33,253.61 -412.79,407.55 -77.23,102.08 -143.66,212.39 -195.05,329.71 -45.79,104.53 -78.33,206.6 -144.95,301.02 -22.5,-105.89 -5.68,-193.82 34.18,-292.84 18.3,-45.48 66.63,-111.24 66.39,-158.86 -0.21,-37.57 -0.09,-75.14 0.01,-112.71 0.31,-107.38 -37.85,-277.55 49.4,-351.22 82.24,69.46 48.95,213.36 49.29,312.46 73.16,-108.59 157.9,-211.13 251.13,-302.98 122.48,-124.11 264.47,-264.44 444.44,-286.89 -45.74,63.63 -74.74,103.95 -142.05,154.76"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path48",
    style: {
      fill: "#393536",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2738.45,2553.35 c -67.19,190.25 -71.32,363.73 -130.05,536.92 -27.3,86.8 -63.48,175.41 -122.92,261.41 -59.47,84.72 -149.7,166.21 -272.87,205.34 -65.86,21.63 -169.81,39.44 -296.26,22.18 -125.9,-14 -279.51,-85.82 -376.72,-225.51 -98.9,-136.96 -148.65,-312.35 -187.78,-487.52 -20.41,-87.38 -36.07,-178.28 -64.88,-259.6 -31.15,-77.02 -85.92,-152.47 -138.77,-222.96 -108.44,-141.29 -227.259,-278.77 -295.88,-434.12 -73.164,-153.84 -78.808,-318 -64.699,-445.36 28.277,-261.18 119.77,-410.73 115.703,-410.91 2.645,3.04 62.66,-161.587 248.916,-346.697 180.46,-184.648 515.42,-366.164 890.53,-353.386 373.73,0.484 742.83,204.011 941.69,464.851 208.26,258.812 256.49,539.002 265.59,669.792 28.6,251.09 -66.4,447.11 -171.9,590.53 -105.58,148.75 -233.04,262.6 -339.7,435.04 89.82,-182.46 208.8,-310.19 302.6,-460.2 94.49,-148.03 174.83,-323.31 148.11,-560.42 -8.93,-124.38 -54.78,-390.36 -252.77,-636.343 C 2747.22,648.43 2396.79,455.137 2041.55,454.59 1684.88,442.383 1366.89,614.707 1195.12,790.242 1017.95,966.184 960.902,1122.64 958.359,1119.73 c 3.887,0.21 -83.011,142.28 -109.808,390.52 -13.137,123.79 -8.106,270.39 59.742,414.1 63.723,144.83 178.017,278.15 288.857,422.07 54.59,73.67 109.86,146.81 147.54,238.87 31.93,90.8 46.66,180.24 67.2,267.35 38.44,173.32 87.45,340.64 177.52,464.9 88.57,126.01 220.66,187.23 335.45,200.87 116.06,15.88 211.05,-0.52 268.98,-19.53 220.96,-74.21 309.75,-264.15 372.18,-423.23 66.75,-164.25 86.61,-337.67 172.43,-522.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path50",
    style: {
      fill: "#b8dd16",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2738.45,2553.35 c -118.64,225.42 -99.21,1002.4 -720.48,1002.4 -642.18,0 -601.84,-776.98 -720.48,-1002.4 -151.36,-287.63 -485.537,-513.69 -485.537,-924.09 0,-666.069 539.947,-1206.006 1206.017,-1206.006 666.07,0 1206.01,539.937 1206.01,1206.006 0,410.41 -334.18,636.47 -485.53,924.09"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path52",
    style: {
      fill: "#4b5c22",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 2017.97,961.094 C 1858.08,929.734 1693,660.422 1542.86,773.145 1326.61,935.52 1279.3,1246.73 1229.61,1493.62 c -55.84,277.51 -7.23,475.1 177.51,691.15 131.63,153.93 264.47,376.23 323.69,572.28 89.17,295.17 -78.39,534.47 88.7,768.85 -436.36,-144.38 -417.25,-773.49 -522.02,-972.55 -151.36,-287.63 -485.537,-513.69 -485.537,-924.09 0,-666.069 539.947,-1206.006 1206.017,-1206.006 177.3,0 345.46,38.555 497.07,107.266 -99.24,38.359 -133.91,66.941 -241.25,138.203 -114.83,76.218 -118.81,319.246 -255.82,292.371"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path54",
    style: {
      fill: "#583517",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2138.04,783.594 c -39.56,117.937 -504.68,24.375 -470.57,-112.5 25.29,-101.492 396.66,-47.981 460.14,28.957 l 10.43,83.543"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path56",
    style: {
      fill: "#231818",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2157.67,811.738 c -21.84,65.032 -278.28,13.438 -259.47,-62.043 13.93,-55.957 218.71,-26.433 253.71,15.969 l 5.76,46.074"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path58",
    style: {
      fill: "#cedc10",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1313.14,2141.01 c -92.88,-52.33 -147.25,-254.71 -167.57,-353.96 -37.27,-182.12 22.95,-423.38 81.22,-595.68 38.15,-112.85 105.79,-222.542 200.97,-295.811 89.89,-69.219 92.78,-35.871 165.5,12 4.22,-145.84 34.48,-166.954 160.76,-104.2 33.44,16.621 35.65,41.321 78.89,53.516 37.44,10.566 76.89,-24.578 117.39,-9.055 67.44,25.852 69.02,79.219 64.01,143.02 28.79,-8.235 64.73,-11.731 90.86,-28.445 15.44,48.625 20.96,121.695 12.23,175.665 -18.77,116.06 -86.17,127.4 -146.92,211.74 -74.73,103.74 8.03,99.28 0.43,185.59 -8.23,93.47 -132.66,125.98 -169.5,211.46 -89.35,207.34 215.99,423.22 63.02,603.02 -108.49,127.54 -327.46,57.86 -373.78,-94.01 l -177.51,-114.85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path60",
    style: {
      fill: "#d6e60d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1814.35,3487.97 c -116.44,-89.43 -105.6,-206.53 -104.42,-343.53 1.27,-147.37 19.09,-289.49 169.15,-211.71 85.46,44.28 99.97,78.91 126.09,187.46 14.88,61.9 51.97,200.22 -23.75,232.04 l -167.07,135.74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path62",
    style: {
      fill: "#c9d0ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2321.8,2457.45 c 43.33,-173.7 51.08,-362.05 177.63,-460.87 144.5,-112.88 345.5,-113.74 467.22,-276.98 -43.47,218.56 -212.81,736.18 -347.89,853.33 L 2321.8,2457.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    style: {
      fill: "#d0e5ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2382.75,2297.58 c 55.96,-98.53 92.74,-212.02 186.69,-250.76 107.29,-44.21 229.99,-10.53 331.95,-89.34 -63.68,125.84 -254.98,412.57 -357.26,461 l -161.38,-120.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path66",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2454.71,2326.56 c 37.41,-57.3 63.83,-124.33 121.91,-144.16 66.33,-22.64 139.03,2.25 203.44,-41.44 -43.09,73.47 -169.14,239.16 -232.61,264.52 l -92.74,-78.92"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path68",
    style: {
      fill: "#c9d0ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2072.07,3446.4 c 37.32,-108.47 146.54,-361.77 304.48,-322.74 182.08,44.97 -10.57,279.48 -111.75,322.74 h -192.73"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path70",
    style: {
      fill: "#d0e5ed",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2169.37,3362.67 c 18.2,-52.89 71.45,-176.39 148.47,-157.36 88.77,21.92 -5.16,136.27 -54.5,157.36 h -93.97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path72",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2214.48,3362.67 c 13.76,-40 54.04,-133.41 112.3,-119.02 67.15,16.58 -3.9,103.07 -41.22,119.02 h -71.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path74",
    style: {
      fill: "#a08f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1134.07,2106.71 c 57.32,77.16 500.47,464.62 571.1,299.69 -109.33,-51.26 -216.06,-189.6 -290.91,-282.1 -45.64,-56.41 -194.28,-252.55 -249.78,-257.64 l -30.41,240.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path76",
    style: {
      fill: "#a7820f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1177.93,1192.2 c 78.49,-126.06 214.46,-490.286 396.25,-489.79 88.59,0.238 177.48,94.438 280.32,93.188 2.83,81.187 -121.98,94.238 -178.45,123.433 -94.78,48.977 -152.8,126.319 -227.17,198.699 l -270.95,74.47"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path78",
    style: {
      fill: "#a08f0d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2211.13,585.195 c 253.2,-0.09 468.6,66.075 681.18,194.953 C 2698.88,653.809 2556.22,470.789 2315.56,449.441 l -104.43,135.754"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path80",
    style: {
      fill: "#bfcd0b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1663.5,829.082 c 126.88,-45.117 766.91,-42.422 603.28,208.538 -59.73,91.59 -163.26,51.12 -248.27,52.25 -105.26,1.41 -226.99,69.97 -281.94,-72.84 L 1663.5,829.082"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path82",
    style: {
      fill: "#bfcd0b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2153.21,615.793 c 315.1,-30.313 435.35,338.492 689.93,426.257 179.96,62.04 96.42,-174.128 14.85,-249.023 -108.62,-99.726 -437.47,-277.453 -589.07,-253.504 l -115.71,76.27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path84",
    style: {
      fill: "#bfcd0b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1459.33,2151.45 c 154.54,131.54 225.2,232.14 447.17,251.09 108.18,9.23 539.1,-25.88 348.66,-175.93 -114.81,-90.43 -334.73,-136.44 -472.11,-187.18 -61.6,-22.73 -244.72,-91.07 -281.95,-34.16 l -41.77,146.18"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path86",
    style: {
      fill: "#bfcd0b",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1720.38,3352.23 c 71.66,6.22 144.11,41.35 216.75,55.07 77.38,14.62 181.64,-4.86 253.29,18.03 82.76,26.41 71.12,62.02 -10.65,104.37 -120.62,62.49 -336.74,33.82 -417.64,-52.18 l -41.75,-125.29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path88",
    style: {
      fill: "#6b5f08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1117.83,1378.77 c -15.83,-177.08 169.13,-442.364 332.25,-512.11 138.61,-59.265 122.6,47.324 85.14,155.07 -51.17,147.16 -134.17,266.02 -219.25,396.43 -24,36.81 -170.57,274.95 -187.7,138.11 l -10.44,-177.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path90",
    style: {
      fill: "#467623",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 811.949,1598.05 c 0,-177.44 5.785,-340.01 85.352,-503.28 41.316,-84.79 200.999,-402.282 217.969,-152.7 16.78,247.15 -86.38,506.18 -94.74,755.19 -3.19,95.45 21.93,166.31 -82.264,197.3 -17.563,-14.11 -28.344,-32.91 -32.344,-56.37 l -93.973,-240.14"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path92",
    style: {
      fill: "#467623",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1490.65,3091.19 c -49.24,-56.62 -185.35,-340.97 -112.2,-414.77 89.15,-89.93 220.45,338.27 227.06,425.21 l -114.86,-10.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path94",
    style: {
      fill: "#9a461d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1957.8,4024.03 c 31.37,-111.32 -12.36,-272.83 138.78,-295.75 16.06,32.23 -2.63,66.82 -18.37,96.57 -13.76,26.03 -25.48,64.72 -44.79,85.75 l -75.62,113.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path96",
    style: {
      fill: "#4c200c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2216.17,3696.36 c 11.81,-63.63 47.31,-115.15 87.28,-165.18 15.38,-19.28 107.08,-132.54 136.72,-102.61 -22.62,43.82 -72.05,76.88 -82.23,126 l -141.77,141.79"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path98",
    style: {
      fill: "#8e7859",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1945.18,4124.85 c -13.7,-14.27 -36.72,-82.03 2.69,-63.16 1.08,-21.5 -9.15,-103.52 29.08,-85.16 5.14,-13.17 7.31,-30.26 12.12,-43 3.1,2.58 7.1,4.83 9.92,7.62 10.72,-36.54 16.65,-62.9 52.69,-83.79 4.43,43.67 -23.68,95.95 -34.02,138.32 l -72.48,129.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path100",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1989.04,4024.03 c 0,0 72.42,-270.98 227.13,-386.4 14.38,9.67 -202.19,260.38 -227.13,386.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path102",
    style: {
      fill: "#001f38",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2105.6,4129.61 c -2.85,-131.05 -95.91,-220.59 -208.78,-269.42 -94.36,-40.82 -100.98,-119.55 -130.36,-207.22 -62.5,-186.5 -306.16,32.2 -406.26,-102.31 -24.43,-32.83 -31.64,-67.55 -33.88,-107.77 -3.31,-59.3 -8.04,-110.25 -41.77,-160.96 -28.7,-43.14 -74.32,-75.03 -113.98,-107.19 -41.38,-33.54 -81.72,-68.29 -120.33,-105 -147.697,-140.43 -238.72,-317.36 -183.252,-522.95 8.348,3.52 16.7,7.04 25.047,10.56 -76.562,121.42 -183.644,220.46 -257.508,343.52 -73.554,122.54 -97.015,278.98 -98.875,419.67 -3.601,273.23 152.692,528.7 371.766,683.77 109.752,77.69 235.162,135.42 364.082,172.79 101.06,29.29 219.25,57.16 324.61,41.67 119.8,-17.62 240.08,-48.35 359.18,-71.38 53.45,-10.33 106.91,-20.67 160.36,-31 17.27,-3.34 24.64,23.08 7.29,26.43 -119.64,23.13 -239.29,46.26 -358.94,69.39 -44.39,8.59 -88.8,17.17 -133.2,25.75 -94.67,18.31 -185.48,6.18 -279.74,-13.29 C 1121.03,4177.16 886.859,4062.39 730.961,3883.63 564.008,3692.18 488.184,3460.69 515.492,3208.1 c 12.649,-116.97 42.774,-233.44 103.672,-334.9 70.969,-118.24 175.578,-212.92 249.199,-329.69 8.231,-13.05 29.176,-4.72 25.051,10.56 -62.687,232.38 73.774,410.04 240.816,554.8 67.95,58.88 150.2,108.92 192.66,190.92 43.01,83.04 -6.89,233.58 105.08,266.57 70.65,20.81 153.27,-20.2 225.55,-20 77.75,0.22 122.2,53.11 142.83,123 13.72,46.5 19.79,94.41 53.48,131.85 37.29,41.45 104.36,50.02 148.69,83.05 76.75,57.19 128.41,149.62 130.48,245.35 0.39,17.68 -27.02,17.64 -27.4,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path104",
    style: {
      fill: "#60b032",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2119.3,4129.61 c 1.07,-92.65 -53.91,-176.25 -123.69,-233.51 -43.15,-35.42 -100.59,-43.22 -141.78,-76.47 -72.33,-58.4 -46.78,-174.07 -112.62,-230.39 -110.78,-94.82 -311.45,85.66 -387.86,-75.66 -17.8,-37.55 -11.33,-88.01 -16.32,-128.97 -11.6,-95.4 -61.54,-142.91 -134.37,-201.45 -197.68,-158.82 -404.594,-346.52 -322.461,-632.73 -70.066,113.84 -166.808,205.91 -240.488,316.17 -74.367,111.27 -104.883,257.52 -115.117,389.57 -19.008,245.2 64.941,446.88 226.73,630 124.012,140.35 337.176,253.5 516.536,304.14 84.48,23.86 279.28,65.37 359.05,34.49 l 492.39,-95.19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path106",
    style: {
      fill: "#3d6f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2119.3,4129.61 c 0,0 -1311.058,-230.73 -1254.823,-1406.89 22.57,193.61 183.193,335.91 338.183,460.44 72.83,58.54 122.77,106.05 134.37,201.45 4.99,40.96 -1.48,91.42 16.32,128.97 76.41,161.32 277.08,-19.16 387.86,75.66 65.84,56.32 40.29,171.99 112.62,230.39 41.19,33.25 98.63,41.05 141.78,76.47 69.78,57.26 124.76,140.86 123.69,233.51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path108",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2108.29,4148.73 c 0,0 -1067.76,-168.89 -1234.653,-1146.38 2.394,-7.15 25.394,180.08 158.263,403.97 157.55,265.47 469.6,582.45 1084.94,687.99 l -8.55,54.42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path110",
    style: {
      fill: "#388228",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 924.293,3230.54 c -24.188,-86.85 -56.063,-215.22 -100.332,-290.13 -68.191,40.69 -121.578,-10.23 -174.805,-52.93 -29.039,45.26 -44.793,114.41 -34.922,168.39 9.536,52.14 -10.113,30.89 36.856,69.89 36.094,29.96 111.863,45.53 157.215,50.22 -88.836,5.66 -172.563,25.57 -242.336,-37.8 -0.77,83.86 125.554,135.57 187,112.16 l 171.324,-19.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path112",
    style: {
      fill: "#388228",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 962.031,3363.57 c 12.207,-5.12 -447.258,0.11 -405.871,13.39 24.492,146.74 275.153,84.33 379.391,74.21 1.836,-7.6 1.707,-15.24 -0.41,-22.92 l 26.89,-64.68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path114",
    style: {
      fill: "#388228",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 704.004,3774.87 c 61.465,60.74 98.516,135.33 189.012,132.97 61.925,-1.62 157.464,-38.66 207.164,-60.19 -56.79,31.28 -81.99,115.53 -162.66,103.6 85.34,48.07 183.07,-16.64 243.17,-76.03 42.57,-42.08 102.27,-95.23 32.54,-118.67 -53.57,-18 -162.41,36.87 -215.886,48.31 -84.77,18.16 -222.813,39.7 -293.34,-29.99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path116",
    style: {
      fill: "#23551e",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1202.07,3611.53 c 127.63,111 269.19,235.21 422.02,310.69 34.66,17.1 330.54,117.92 349.05,44.36 5.58,-22.2 -106.62,-101.93 -125.04,-125.49 -34.37,-43.98 -47.24,-73.77 -102.7,-93.22 -70.85,-24.81 -185.13,-22.82 -261.19,-30.41 l -282.14,-105.93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path118",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1289.93,3341.8 c 0,0 -52.93,280.97 0,379.09 l 12.82,32.58 c 0,0 -38.92,-176.74 -12.82,-411.67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path120",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1009.08,3133.04 c 0.23,-3.68 -25.584,233.55 20.48,293.7 2.46,-2.23 18.84,30.35 18.84,30.35 0,0 -52.892,-105.92 -39.32,-324.05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path122",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1409.09,3849.3 c 0,0 -126.16,204.06 -418.793,156.42 3.004,-10.67 297.163,27.26 382.703,-183.25 2.59,1.98 36.09,26.83 36.09,26.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path124",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1177.93,3615.61 c 0,0 -243.262,163.96 -503.164,89.47 3.015,-10.67 287.675,72.56 467.094,-116.3 2.59,1.98 36.07,26.83 36.07,26.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path126",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1035.57,3415.21 c 0,0 -180.945,167.09 -432.504,57.98 3.004,-10.67 217.016,104.04 396.43,-84.81 2.584,1.98 36.074,26.83 36.074,26.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path128",
    style: {
      fill: "#3d6f1d",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1208.77,4157.96 c 122.15,19.4 460.29,162.13 508.72,-44.41 -89.5,1.68 -174.43,5.85 -260.74,-2 -78.12,-7.09 -178.63,-41.42 -251.61,-5.67 l 3.63,52.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path130",
    style: {
      fill: "#6b5f08",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1665.68,3162.93 c 0,0 -14.49,205.1 96.45,314.59 57.38,48.38 76.07,2.63 54.42,-53.95 -21.66,-56.59 -116.71,-412.36 -150.87,-260.64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path132",
    style: {
      fill: "#fff200",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 2072.07,2156.77 c -160.75,34.38 -444.27,-199.29 -444.27,-199.29 v -20.12 c 263.5,-1181.989 615.3,-488.21 619.28,-370 3.97,118.19 -14.26,555.01 -175.01,589.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path134",
    style: {
      fill: "#4d9829",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1035.57,2140.96 -10.34,15.81 c 0,0 -287.902,-270.79 -195.394,-738.46 41.109,-61.67 84.574,-35.97 88.539,66.82 3.965,102.78 194.855,721.92 117.195,655.83"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path136",
    style: {
      fill: "#4d9829",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1459.33,2816.15 c -7.66,102.79 -60.77,8.05 -147.28,-224.66 l -27.47,-61.67 c 0,0 182.42,183.55 174.75,286.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path138",
    style: {
      fill: "#4d9829",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1561.36,512.781 c 0,0 429.56,42.16 578.78,-24.644 149.22,-66.821 -335.47,-68.899 -578.78,24.644"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path140",
    style: {
      fill: "#9bc421",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1985.85,4075.72 c 0,0 178.42,39.32 241.01,-0.35 8.21,-9.37 -9.8,88.34 -144.19,63.66 -134.42,-24.67 -96.82,-63.31 -96.82,-63.31"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPearIllustration);
export default __webpack_public_path__ + "static/media/pear-illustration.a8b7b306a981f0ffbdf5bff947898999.svg";
export { ForwardRef as ReactComponent };